export class Flicker {
  static readonly INTERVAL_MS = 2000;

  private subscribers = new Set<() => void>();

  private interval: ReturnType<typeof setInterval> | null = null;

  private registered = new Map<number | string, number>();

  constructor() {}

  add(id: number | string, ticks: number) {
    this.registered.set(id, ticks);
    if (this.registered.size === 1) {
      this.start();
    }
  }

  remove(id: number | string) {
    this.registered.delete(id);
    if (this.registered.size === 0) {
      this.stop();
    }
  }

  subscribe(callback: () => void) {
    this.subscribers.add(callback);
    return () => this.unsubscribe(callback);
  }

  unsubscribe(callback: () => void) {
    this.subscribers.delete(callback);
  }

  private send() {
    this.subscribers.forEach((callback) => callback());
  }

  private tick() {
    this.send();
    this.registered.forEach((ticks, id) => {
      if (ticks > 0) {
        this.registered.set(id, ticks - 1);
      } else {
        this.remove(id);
      }
    });

    if (this.registered.size === 0) {
      this.stop();
    }
  }

  private start() {
    if (!this.interval) {
      this.tick();
      this.interval = setInterval(() => {
        this.tick();
      }, Flicker.INTERVAL_MS);
    }
  }

  private stop() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  stopImmediate() {
    this.registered.clear();
    this.stop();
  }
}
